import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----


const initialState = Immutable({
	checkpoint: {
		state: {},
		inboxLastMsgId: 0,
		fetchNextTurnAfterReload: false,
	},
});

function reducerEnhancer(appReducer) {
	//	the checkpoint was fully moved to the backend
	return (state = initialState, action = {}) => {
		switch (action.type) {
		case types.CHECKPOINT_LOADED:
			return getStateAfterLoadingCheckpoint(state, action);
	
		case types.CHECKPOINT_SAVE:
			return getStateAfterSavingCheckpoint(state, action);

		case types.CHECKPOINT_RELOAD:
			return state;

		default:
			const { checkpoint, ...rest } = state;
			const updated = appReducer(rest, action);
			if (rest === updated) {
				return state;
			}

			return state.merge({
				...updated
			});
		}
	};
}

function getStateAfterLoadingCheckpoint(state, action) {
	return state.merge({
		checkpoint: {
			state: action.checkpoint?.state ?? {},
			inboxLastMsgId: action.checkpoint?.inboxLastMsgId ?? 0,
			fetchNextTurnAfterReload: action.checkpoint?.fetchNextTurnAfterReload ?? false,
		}
	});
}

function getStateAfterSavingCheckpoint(state, action) {
	const { checkpoint, ...present } = state;

	return state.merge({
		checkpoint: {
			state: present,
			inboxLastMsgId: action.inboxLastMsgId,
			fetchNextTurnAfterReload: action.fetchNextTurnAfterReload
		},
	});
}


function getStateAfterReloadingCheckpoint(state) {
	const { checkpoint } = state;

	return state.merge({
		...checkpoint.state,
	});
}


export default reducerEnhancer;
